import type {
  AnyQuestionModule,
  QuestionArrangement,
  QuestionResponseFlow,
} from "./contracts";

export const resolveQuestionView = (
  module: AnyQuestionModule,
  request: unknown,
  arrangement: QuestionArrangement,
  override?: string,
  preferredFlow?: QuestionResponseFlow,
): string => {
  if (override) return override;
  const requested = module.resolveDisplay?.(request, arrangement).view;
  if (requested) return requested;
  return (
    (preferredFlow
      ? Object.values(module.views).find(
          (descriptor) => descriptor.responseFlow === preferredFlow,
        )?.id
      : undefined) ?? module.defaultDisplay.view
  );
};

export type SelectViewId = "buttons" | "list" | "dropdown";
export const selectViewFromStyle = (style: string | undefined): SelectViewId =>
  style === "dropdown" ? "dropdown" : style === "list" ? "list" : "buttons";
